import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";
// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "(default)",
  COLLECTIONS: {
    SETTING: "setting",
    WALLET: "wallet",
    BANK: "bank",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    setting: collection(firestore, REF.COLLECTIONS.SETTING),
    wallet: collection(firestore, REF.COLLECTIONS.WALLET),
    bank: collection(firestore, REF.COLLECTIONS.BANK),
  };
  return CREF;
};
